import { AxiosResponse } from "axios";
import axiosInstance from "../../../interceptors/axiosInstance";
import { ListaResponsables, UpdateResponsables } from "../hooks/useResponsables";
import { ListResponseDto } from "../../../dtos/ListResponseDto";
import { selectorTransversal } from "../../../dtos/selector";
import { ejecutivo } from "../models/operacion";



const getAbogados = async () => {

  const axiosResponse: Promise<AxiosResponse<ListResponseDto<ListaResponsables>>> = axiosInstance.get(`siscred-api-mutuo/v1/responsables/obtener-abogado`,);

  return axiosResponse;
};

const getEjecutivo = async () => {
    const axiosResponse: Promise<AxiosResponse<ListResponseDto<ejecutivo>>> = axiosInstance.get(`siscred-api-mutuo/v1/responsables/obtener-ejecutivo`,);

    return axiosResponse;
};

const getEjecutivoOperaciones = async () => {
    const axiosResponse: Promise<AxiosResponse<ListResponseDto<ListaResponsables>>> = axiosInstance.get(`siscred-api-mutuo/v1/responsables/obtener-confeccionador`,);

    return axiosResponse;
};

const getResponsables = async (mutuoId: number) => {
    const response: AxiosResponse = await axiosInstance.get(
        `siscred-api-mutuo/v1/responsables/obtener-responsable?mutuoId=${mutuoId}`
    );
    return response;
};

const actualizarResponsables = async (data : UpdateResponsables) => {

    const response: AxiosResponse = await axiosInstance.put(`siscred-api-mutuo/v1/responsables/actualizar-responsable/${data.mutuoId}`, data);
    return response;
}

const copiarResponsables = async (idSolicitud : string) => {

    const response: AxiosResponse = await axiosInstance.post(`siscred-api-mutuo/v1/responsables/copiar-responsable`, {
        idSolicitud: Number(idSolicitud)
    });
    return response;
}

export {
    getAbogados,
    getEjecutivo,
    getEjecutivoOperaciones,
    getResponsables,
    actualizarResponsables,
    copiarResponsables
}